import React from 'react';

const PillButtonGroup = ({ options, value, onChange }) => (
  <div className="ef-pills" role="radiogroup">
    {options.map((option) => {
      const selected = value === option;
      return (
        <button
          key={option}
          type="button"
          className={['ef-pill', selected ? 'ef-pill--selected' : ''].filter(Boolean).join(' ')}
          onClick={() => onChange(option)}
          aria-checked={selected}
          role="radio"
        >
          {option}
        </button>
      );
    })}
  </div>
);

export default PillButtonGroup;
